export const
  DISPOSABLE = 'disposable',  // a throwaway email such as mailinator.com
  GENERIC = 'generic',  // a big email hoster such as hotmail.com
  CUSTOM = 'custom'  // a custom domain eg brandly.com
  ;
const DOMAINS = {
  // This is just enough to test if we ever create a different path.
  "mailinator.com": DISPOSABLE,

  // This is not exhaustive at all but covers the vast majority of our generic emails.
  "gmail.com": GENERIC,
  "hotmail.com": GENERIC,
  "yahoo.com": GENERIC,
  "aol.com": GENERIC,
}
export default function emailDomainType(email) {
  let domain = email.split('@', 2)[1].toLowerCase().trim();
  return DOMAINS[domain] || CUSTOM;
}



// WEBPACK FOOTER //
// ./src/lib/emailDomainType.js